export const GET_ALL_PHOTO_SOL = 'GET_ALL_PHOTO_SOL';
export const SET_NAME = "SET_NAME";
export const SET_ORDER = "SET_ORDER";
export const SET_FILTER = "SET_FILTER";
export const SET_FILTER_ORDER = "SET_FILTER_ORDERS";
export const SET_PAGE = "SET_PAGE";
export const GET_PHOTO_SOL = 'GET_PHOTO_SOL';
export const FILTER_STATUS = "FILTER_STATUS";
export const SET_FORMULARIO = "SET_FORMULARIO";
export const SET_SEARCH = "SET_SEARCH";